import shallow from 'zustand/shallow';
import useCashInfoStore from 'global/Securities/stores/useCashInfoStore';
import { PaymentMethod } from 'global/Securities/types/transaction';
import tradingDataStore from 'lib/stores/tradingData';

const useTransactionBalance = (
  paymentMethod: PaymentMethod = PaymentMethod.TradingBalance,
) => {
  const portfolioTradingBalance = tradingDataStore(
    (s) => s.portfolio.data?.tradingbalance,
  );
  const balanceList = useCashInfoStore(
    (s) => ({
      [PaymentMethod.TradingBalance]:
        s.tradingBalance || portfolioTradingBalance,
      [PaymentMethod.TradingLimit]: s.tradingLimit,
      [PaymentMethod.DayTrade]: s.dayTrade,
    }),
    shallow,
  );

  return [balanceList[paymentMethod], ...Object.values(balanceList)];
};

export default useTransactionBalance;
